import { useEffect, useState } from 'react';
import LayoutWithSidebar from '../../components/common/layoutWithSidebar';
import KnowledgeBAseFiles from '../../components/KnowledgeBase/KnowledgeBAseFiles';
import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { Box } from '@mui/material';
import { HeaderContainer } from '../../components/dashboard/AgentInfoHeader';
import theme from '../../theme';
import Questionnaire from '../../components/KnowledgeBase/Questionnaire';
import { useStores } from '../../components/UserJourny/FirstUserJourney/useStores';

const GeneralSupportList = () => {
  const [selectedStore, setSelectedStore] = useState<any>(null);
  const [selectedMethod, setSelectedMethod] = useState<string>('file-upload');
  const [isNewQuestion, setIsNewQuestion] = useState(false);

  const { storesList, storesListLoading } = useStores();

  const handleStoreChange = (event: SelectChangeEvent) => {
    const store = storesList?.find(
      (store: any) => store.friendly_name === event.target.value
    );
    setSelectedStore(store);
  };

  const handleMethodChange = (event: SelectChangeEvent) => {
    setSelectedMethod(event.target.value);
  };

  useEffect(() => {
    if (storesList?.length > 0 && !selectedStore) {
      setSelectedStore(storesList[0]);
    }
  }, [storesList, selectedStore]);

  useEffect(() => {
    if (selectedStore && storesList?.length > 0) {
      const updatedStore = storesList.find(
        (store: any) => store.id === selectedStore.id
      );
      if (updatedStore) {
        setSelectedStore(updatedStore);
      }
    }
  }, [storesList, selectedStore]);

  return (
    <LayoutWithSidebar margin={2}>
      <HeaderContainer>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'DM Sans',
              fontWeight: 600,
              fontSize: '24px',
              lineHeight: '100%',
              letterSpacing: '-0.01em',
              color: '#2B2D3F',
              width: '100%',
            }}
          >
            General Support
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: 'auto',
                gap: '8px',
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: '12px',
                  fontWeight: 400,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                General Support Methods
              </Typography>
              <Select
                value={selectedMethod}
                onChange={handleMethodChange}
                sx={{
                  '& .MuiSelect-select': {
                    display: 'flex',
                    padding: '8px 12px',
                    alignItems: 'center',
                    borderRadius: '6px',
                    border: '1px solid #DCE0E7',
                    background: '#F8F9FC',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    letterSpacing: '-0.14px',
                    color: theme.palette.lightGray.text,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                  minWidth: '140px',
                }}
              >
                <MenuItem value="file-upload">Upload File</MenuItem>
                <MenuItem value="questionnaire">Questionnaire</MenuItem>
              </Select>
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: '12px',
                  fontWeight: 400,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                Setting Up For
              </Typography>
              <Select
                value={selectedStore?.friendly_name || ''}
                onChange={handleStoreChange}
                sx={{
                  '& .MuiSelect-select': {
                    display: 'flex',
                    padding: '8px 12px',
                    alignItems: 'center',
                    borderRadius: '6px',
                    border: '1px solid #DCE0E7',
                    background: '#F8F9FC',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    letterSpacing: '-0.14px',
                    color: theme.palette.lightGray.text,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                  minWidth: '140px',
                }}
              >
                {storesList?.map((store: any) => (
                  <MenuItem
                    key={store.id}
                    value={store.friendly_name}
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                    }}
                  >
                    {store.friendly_name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
        </Box>
      </HeaderContainer>

      {selectedMethod === 'file-upload' ? (
        <KnowledgeBAseFiles
          isGeneralSupport={true}
          selectedStoreId={selectedStore?.id}
          isStoreLoading={storesListLoading}
          borderRadius="12px"
          border="1px solid #DCE0E7"
        />
      ) : (
        <Questionnaire
          borderRadius="12px"
          isGeneralSupport={true}
          height="100%"
          border="1px solid #DCE0E7"
          selectedStore={selectedStore}
          isNewQuestion={isNewQuestion}
          setIsNewQuestion={setIsNewQuestion}
          isStoreLoading={storesListLoading}
        />
      )}
    </LayoutWithSidebar>
  );
};

export default GeneralSupportList;
